import { LivenessError } from "@aws-amplify/ui-react-liveness/dist/types/components/FaceLivenessDetector/service";

import { Banner, BannerProps } from "@shared/components";
import { useWebcam } from "@shared/hooks/useWebcam";
import Message from "@shared/services/message";
import { getLivenessErrorMessage } from "@shared/services/webcam";

interface LivenessResultProps extends BannerProps {
  type: BannerProps["type"];
  livenessError?: LivenessError | null;
}

export const LivenessResult = ({
  type,
  livenessError,
}: LivenessResultProps) => {
  const { videoRef } = useWebcam();

  const text =
    type === "success"
      ? {
          title: Message.getMessageByKey(
            "applicant.liveness.success.banner.title",
          ),
          description: Message.getMessageByKey(
            "applicant.liveness.success.banner.description",
          ),
        }
      : {
          title: Message.getMessageByKey(
            "applicant.liveness.failed.banner.title",
          ),
          description: getLivenessErrorMessage(livenessError || null),
          type: "error",
        };

  return (
    <div className="code-liveness-result">
      <Banner type={type} className="code-liveness-result__banner">
        <article>
          <h4>{text.title}</h4>
          <p>{text.description}</p>
        </article>
      </Banner>
      <div className="code-liveness-result__content">
        <video ref={videoRef} muted className="code-liveness-result__img" />
      </div>
    </div>
  );
};
